import React, { useState, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FullCard from '../../../../../components/Card/FullCard';
import { makeStyles } from '@material-ui/core/styles';
import { store } from '../../../../../store';
import axios from '../../../../../api/axios';
import useTitle from 'hooks/useTitle';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'column nowrap',
    '& > *:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },
}));

const Password = () => {
  useTitle('گذرواژه');
  const classes = useStyles();
  const [state, setState] = useState({
    adminPass: '',
    verifyPass: '',
    error: {},
  });
  const { adminPass, verifyPass, error } = state;
  const { showMessage, showError } = useContext(store);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    let { name, value } = e.target;
    value = value.trim(value);
    setState({ ...state, [name]: value });
  };
  const validate = () => {
    let error = {};
    if (!adminPass || !verifyPass) {
      error.adminPass = 'گذرواژه و تکرارگذرواژه هردو بایستی وارد شوند';
      error.verifyPass = 'گذرواژه و تکرارگذرواژه هردو بایستی وارد شوند';
    }
    if (!adminPass) error.adminPass = 'گذرواژه را وارد نمائید.';
    else if (adminPass?.length < 6)
      error.adminPass = 'طول گذرواژه بایستی بیشتر از ۶ کاراکتر باشد';
    if (adminPass && verifyPass && adminPass !== verifyPass)
      error.verifyPass = 'تکرار گذرواژه مطابقت ندارد.';
    if (Object.entries(error).length) {
      setState({ ...state, error });
      return false;
    }
    return true;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      try {
        setLoading(true);
        const { data } = await axios.post(
          `/api/v1/admin/users/changeMyPassword`,
          {
            adminPass,
          }
        );
        if (data.ok) {
          showMessage(data.messages);
        }
      } catch (error) {
        showError(error);
      }
      setLoading(false);
      return;
    }
  };

  return (
    <FullCard title="تغییر گذرواژه">
      <form
        style={{ width: 500 }}
        className={classes.root}
        onSubmit={handleSubmit}
        onKeyPress={(e) => e.key === 'Enter' && handleSubmit(e)}
      >
        <TextField
          label="گذرواژه"
          name="adminPass"
          value={adminPass}
          type="password"
          fullWidth
          variant="outlined"
          size="medium"
          onChange={handleChange}
          error={!!error?.adminPass}
          helperText={error?.adminPass || ''}
        />
        <TextField
          label="تکرار گذرواژه"
          name="verifyPass"
          value={verifyPass}
          type="password"
          fullWidth
          variant="outlined"
          size="medium"
          onChange={handleChange}
          error={!!error?.verifyPass}
          helperText={error?.verifyPass || ''}
        />
        <Button
          variant="contained"
          size="large"
          fullWidth
          color="secondary"
          onClick={handleSubmit}
          disabled={loading}
          endIcon={loading ? <CircularProgress size={10} /> : <></>}
        >
          ذخیره
        </Button>
      </form>
    </FullCard>
  );
};

export default React.memo(Password);
